import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import {ListMessage, SimpleMessage} from './components';

const CustomAlert = (props) => {
  return(
    <Alert color={props.type}>
      { typeof props.message === 'string' ? <SimpleMessage {...props} /> : <ListMessage messages={props.message} /> }
    </Alert>
  );
};

CustomAlert.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired
};

export default CustomAlert;